import axios from "axios";

export const fetchDataModel = () => {
  return axios
    .post("/datamodel")
    .then((response) => {
      if (response.data.code === 200) {
        return response.data.tables;
      } else {
        alert(response.data.message);
      }
    })
    .catch((err) => {
      console.log(
        "[assortment_management.actions.js] loginAPI || Could not fetch data model. Try again later."
      );
    });
};

export const fetchDataFromTable = (table) => {
  return axios
    .post("/data", { table: table })
    .then((response) => {
      if (response.data.code === 200) {
        return response.data.data;
      } else {
        alert(response.data.message);
      }
    })
    .catch((err) => {
      console.log(
        "[assortment_management.actions.js] loginAPI || Could not fetch data content. Try again later."
      );
    });
};

export const uploadNewRecord = (table, body) => {
  return axios
    .post("/insert", { table: table, data: body })
    .then((response) => {
      if (response.data.code === 200) {
        alert(response.data.message);
        return true;
      } else {
        alert(response.data.message);
        return false;
      }
    })
    .catch((err) => {
      console.log(
        "[assortment_management.actions.js] uploadNewRecord || Could not upload new record. Try again later."
      );
    });
};
